import { createTheme } from '@mui/material/styles';

const pxToRem = (value: number) => {
    return `${value / 16}rem`;
}

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 992,
            lg: 1367,
            xl: 1536
        }
    },
    palette: {
        primary: {
            main: '#0C1C33',
            light: '#17A7E0',
            '50': '#1E5F91',
            '100': '#1C386B',
            '200': '#152949',
        },
        secondary: {
            main: '#97C93D',
            light: '#CBE49E',
            dark: '#67990F'
        },
        error: {
            main: '#FF0000',
        },
        grey: {
            '50': '#D5D7D7',
            '100': '#C0C2C2',
            '200': '#C4C4C4',
            '300': '#9C9DB7',
            '400': '#8D9BB5',
            '500': '#5D6779',
            '600': '#76797A',
        }
    },
    shape: {
        borderRadius: 5
    },
    typography: {
        fontFamily: ['PFBeau'].join(','),
        allVariants: {
            lineHeight: 1,
            color: '#0C1C33',
            WebkitFontSmoothing: 'antialiased',
        },
        h1: {
            fontWeight: 700,
            fontSize: pxToRem(30),
        },
        h4: {
            fontWeight: 700,
            fontSize: pxToRem(30),
        },
        h5: {
            fontSize: pxToRem(25),
        },
        h6: {
            fontSize: pxToRem(16),
            fontWeight: 600,
        },
        subtitle1: {
            fontWeight: 700,
        },
        subtitle2: {
            fontSize: pxToRem(14),
        },
        body2: {
            fontWeight: 600,
            fontSize: '.75rem',
        },
        caption: {
            fontWeight: 500,
            fontSize: '.8125rem',
        },
        overline: {
            color: '#F44336',
            paddingTop: '.1rem',
            fontSize: '.8125rem',
            textTransform: 'none',
        }
    },
});

export default theme;